import {HTTP} from "@/utils/httpCommonUtil";
import Vue from "vue";

export async function httpGet(path: string, error?: string): Promise<any> {
  const results = await execute('get', path, null, error);
  if (results) {
    return results.data;
  }
}

export async function httpPost(path: string, body: any, error?: string): Promise<any> {
  const results = await execute('post', path, body, error);
  if (results) {
    return results.data;
  }
}

export async function httpPut(path: string, body: any, error?: string): Promise<void> {
  const results = await execute('put', path, body, error);
  if (results) {
    return results.message;
  }
}

export async function httpDelete(path: string, error?: string): Promise<void> {
  const results = await execute('delete', path, null, error);
  if (results) {
    return results.message;
  }
}

async function execute(verb: string, path: string, body?: any, error = 'An unexpected error occurred.'): Promise<any> {
  try {
    const response = await (HTTP as any)[verb]('/api' + path, body);
    if (!response.data || (verb !== 'delete' && !response.data.data)) {
      if (response.data && response.data.message) {
        error = response.data.message;
      }
      throw new Error(error);
    }
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(error);
    }
  } catch (err) {
    if (err.response && err.response.status === 422 && err.response.data) {
      return err.response.data;
    }
    if (err.response && err.response.data && err.response.data.message) {
      error = err.response.data.message;
    }
    (Vue as any).$notify({
      group: 'main',
      type: 'error',
      title: 'Error',
      text: error
    });
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/services/HttpService.ts